<template>
    <div class="message">
        <div v-if="$slots['header']" class="message-header">
            <slot v-if="!showClose" name="header"></slot>
            <div
                v-else
                class="flex-con is-grow"
                style="width:100%;"
            >
                <div>
                    <slot name="header"></slot>
                </div>
                <div class="is-narrow">
                    <span class="icon has-cursor-pointer" @click="$emit('close')">
                        <i class="fa fa-times"></i>
                    </span>
                </div>
            </div>
        </div>
        <div class="message-body flex-con xs-pad-lr is-grow" style="width:100%;">
            <div v-if="!hideIcon" class="icon-con is-narrow">
                <slot name="icon">
                    <span class="icon">
                        <i class="fa fa-exclamation"></i>
                    </span>
                </slot>
            </div>
            <div>
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name : "CommonAlertMessage",
    props : {
        hideIcon : Boolean,
        showClose : Boolean,
    },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_theme.scss';

.icon-con {
    font-size:1.5rem;
}


.is-warning {
    .message-body {
        color:#FF9F43 !important;
        border-color:#f6c8c8 !important;
    }
    .icon-con {
        color:darken($warning, 2);
    }
}

.is-primary .icon-con {
    color:darken($primary, 2);
}

.is-info .icon-con {
    color:darken($info, 30);
}

.is-danger .icon-con {
    color:darken($danger, 2);
}

.is-link .icon-con {
    color:darken($link, 2);
}

</style>
